// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3fClz","gfeWrapper":"CalendarEvent_gfeWrapper__SV3sR"};